<template>
  <ap-input v-model:value="searchTerm" :prefix="h(SearchOutlined)" />
</template>

<script setup>
import { computed, h } from "vue"
import { storeToRefs } from "pinia"
import { SearchOutlined } from "@ant-design/icons-vue"
import { useQrsTableStore } from "@/stores/qrs"
defineOptions({
  inheritAttrs: true
})

const qrsTableStore = useQrsTableStore()
const { filter } = storeToRefs(useQrsTableStore())

const searchTerm = computed({
  get() {
    return filter.value.title
  },
  set(title) {
    qrsTableStore.setFilter({ title })
  }
})
</script>

<style></style>
